/* Trention — Theme JS */
document.addEventListener('DOMContentLoaded', function () {

  /* ── Fade-up on scroll ─────────────────────────── */
  var fadeEls = document.querySelectorAll('.fade-up');
  if (fadeEls.length) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    fadeEls.forEach(function (el) { obs.observe(el); });
  }

  /* ── FAQ accordion ─────────────────────────────── */
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ── Bundle qty selector ───────────────────────── */
  var bundles = [
    { qty: 1, label: '1-Pack — Starter',    sub: '14-day supply · Free shipping',      badge: '$34.99',  priceStr: '$34.99' },
    { qty: 2, label: '2-Pack — Double Up',  sub: '28-day supply · Save $20',           badge: 'Save 29%', priceStr: '$49.99' },
    { qty: 3, label: '3-Pack — Best Value', sub: '42-day supply · Most popular',       badge: 'Save 43%', priceStr: '$59.99' },
    { qty: 4, label: '4-Pack — Max Supply', sub: '56-day supply · Best value per use', badge: 'Save 48%', priceStr: '$72.99' }
  ];
  var activeBundle = 2; // default: 3-pack

  function renderBundles () {
    var wrap = document.getElementById('bundle-qty-wrap');
    if (!wrap) return;
    wrap.innerHTML = '';
    bundles.forEach(function (b, i) {
      var active = i === activeBundle;
      var div = document.createElement('div');
      div.className = 'qty-opt' + (active ? ' active' : '');
      div.innerHTML =
        '<div class="qty-opt-left">' +
          '<div class="qty-radio"><div class="qty-radio-dot"></div></div>' +
          '<div><div class="qty-name">' + b.label + '</div>' +
          '<div class="qty-sub">' + b.sub + '</div></div>' +
        '</div>' +
        '<span class="qty-badge">' + b.badge + '</span>';
      div.addEventListener('click', function () {
        activeBundle = i;
        renderBundles();
        var priceEl = document.getElementById('bundle-price');
        if (priceEl) priceEl.textContent = bundles[i].priceStr;
        var qInput = document.getElementById('bundle-qty-input');
        if (qInput) qInput.value = bundles[i].qty;
        var stickyPrice = document.getElementById('sticky-price');
        if (stickyPrice) stickyPrice.textContent = bundles[i].priceStr;
      });
      wrap.appendChild(div);
    });
  }
  renderBundles();

  /* ── ATC feedback ──────────────────────────────── */
  var atcForm = document.getElementById('trention-atc-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function () {
      var btn = document.getElementById('trention-atc-btn');
      if (!btn) return;
      btn.textContent = 'Adding…';
      btn.style.opacity = '0.75';
      setTimeout(function () {
        btn.textContent = '✓ Added to Cart!';
        btn.style.opacity = '1';
        setTimeout(function () { btn.textContent = 'Start Whitening Today'; }, 2200);
      }, 500);
    });
  }

  /* ── Nav hamburger ─────────────────────────────── */
  var ham = document.querySelector('.nav-hamburger');
  var navLinks = document.querySelector('.nav-links');
  if (ham && navLinks) {
    ham.addEventListener('click', function () {
      navLinks.classList.toggle('open');
    });
  }

  /* ── Sticky ATC scroll trigger ─────────────────── */
  var stickyAtc = document.getElementById('sticky-atc');
  var bundleSection = document.getElementById('get-it');
  if (stickyAtc && bundleSection) {
    var obs2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        stickyAtc.style.opacity = e.isIntersecting ? '0' : '1';
        stickyAtc.style.pointerEvents = e.isIntersecting ? 'none' : 'auto';
      });
    }, { threshold: 0 });
    obs2.observe(bundleSection);
    // Start visible
    stickyAtc.style.opacity = '0';
    stickyAtc.style.pointerEvents = 'none';
  }
});
